let dirPath = 'static/games/page007_game4';

let configGame = {
  removeInCorrects: false,
  correctBlock: false,
  autoCheckAllCorrect: false,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'click' }],
    },
    items: [
      {
        idGroup: 'target',
        idItem: '01tr01',
        block: true,
        items: [
          {
            idGroup: 'source',
            idItem: 'sr01',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 180 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr02',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 90 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr03',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 0 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr04',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 90 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr05',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 180 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr06',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 270 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr07',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 180 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr08',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 0 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr09',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 90 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr10',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 90 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr11',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 0 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr12',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 180 }],
          },
          {
            idGroup: 'source',
            idItem: 'sr13',
            correct: [{ idGroup: 'target', idItem: '01tr01', rotation: 270 }],
          },
        ],
      },
    ],
  },
  layout: {
    groups: [
      {
        idGroup: 'target',
        positions: { type: 'absolute', pos: { x: 360, y: 20, width: 1097, height: 890 } },
        //background: { image: { src: dirPath + '/img/maze.jpg' } },
        background: { color: 'transparent' },
        itemsConfig: {
          positions: { type: 'absolute', pos: { x: 40, y: 40, width: 1017, height: 810 } },
          background: { image: { src: dirPath + '/img/maze.jpg' } },
        },
        items: [{ id: '01tr01' }],
      },
      {
        idGroup: 'source',
        positions: { autoFit: true, type: 'absolute', pos: { x: 400, y: 60, width: 1017, height: 810 } },
        background: { color: 'rgba(0,0,0,0.3)' },
        itemsConfig: {
          positions: { type: 'absolute', pos: { x: 0, y: 0, height: 70, width: 70 } },
          background: { image: { src: dirPath + '/img/arrow.png' } },
        },
        otherProperty: {
          rotateByClick: true,
          angleRotate: 90,
          offMove: true,
          points: {
            pointMouse: {
              color: 'rgba(0,0,0,0.3)',
              rad: 8,
              alwaysShow: false,
            },
            itemsConfig: {
              color: 'rgba(0,0,0,0.3)',
              positions: {
                //  pos: { x: 0, y: 0 },
                rad: 8,
                // setTo: 'center',
                // offset: { x: 0, y: 0 }
              },
              registrationPoint: { setTo: 'center' },
              alwaysShow: false,
            },
            items: [{ id: 'p01', positions: { pos: { setTo: 'center' } } }],
          },
        },
        items: [
          {
            id: 'sr01',
            positions: { pos: { x: 130, y: 35 } },
          },
          {
            id: 'sr02',
            positions: { pos: { x: 130, y: 310 } },
          },
          {
            id: 'sr03',
            positions: { pos: { x: 230, y: 310 } },
          },
          {
            id: 'sr04',
            positions: { pos: { x: 230, y: 115 } },
          },
          {
            id: 'sr05',
            positions: { pos: { x: 520, y: 220 } },
          },
          {
            id: 'sr06',
            positions: { pos: { x: 420, y: 500 } },
          },
          {
            id: 'sr07',
            positions: { pos: { x: 35, y: 500 } },
          },
          {
            id: 'sr08',
            positions: { pos: { x: 230, y: 695 } },
          },
          {
            id: 'sr09',
            positions: { pos: { x: 230, y: 615 } },
          },
          {
            id: 'sr10',
            positions: { pos: { x: 615, y: 410 } },
          },
          {
            id: 'sr11',
            positions: { pos: { x: 710, y: 410 } },
          },
          {
            id: 'sr12',
            positions: { pos: { x: 800, y: 310 } },
          },
          {
            id: 'sr13',
            positions: { pos: { x: 910, y: 500 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'rotate',
  realWidth: 1700,
  realHeight: 890,
  mainImage: {
    imagePath: dirPath + '/img/bgr.jpg',
    pos: {
      y: -7,
      x: 0,
    },
  },
  configGame: configGame,
};

export default dataConfig;
